export default __webpack_public_path__ + "static/media/food03.f3dcb50a.png";